module.exports = __webpack_public_path__ + "img/img_5.0bdd7d90.png";